import { createState as createCardListState } from './card-list';
import { InputHintDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
// State
// =============================================================================
export let StateType;
(function (_StateType) {
  let AuthType = /*#__PURE__*/function (AuthType) {
    AuthType[AuthType["SHOW_ACCOUNT_DETAILS"] = 0] = "SHOW_ACCOUNT_DETAILS";
    AuthType[AuthType["SHOW_BILL_PAY"] = 1] = "SHOW_BILL_PAY";
    AuthType[AuthType["NONE"] = 2] = "NONE";
    return AuthType;
  }({});
  _StateType.AuthType = AuthType;
  let AuthState = /*#__PURE__*/function (AuthState) {
    AuthState[AuthState["SUCCESS"] = 0] = "SUCCESS";
    AuthState[AuthState["ERROR"] = 1] = "ERROR";
    AuthState[AuthState["EXPIRED"] = 2] = "EXPIRED";
    AuthState[AuthState["REJECTED"] = 3] = "REJECTED";
    AuthState[AuthState["NONE"] = 4] = "NONE";
    return AuthState;
  }({});
  _StateType.AuthState = AuthState;
})(StateType || (StateType = {}));
const writeCheckInputHints = {
  amountInputHint: InputHintDescription.create(),
  recipientInputHint: InputHintDescription.create(),
  memoInputHint: InputHintDescription.create()
};
const INITIAL_STATE = {
  authCode: '',
  authIsActiveFor: StateType.AuthType.NONE,
  authModalActive: false,
  authStateResult: StateType.AuthState.NONE,
  balanceIds: [],
  billPayModalActive: false,
  canSeeBillPay: false,
  canSeePrintableCheck: false,
  cardListState: createCardListState(),
  isLoadingCreateCheck: false,
  isLoadingDownloadCheck: false,
  isLoadingPrintCheck: false,
  isToggleDisabled: false,
  isResendButtonActive: true,
  printableCheckModalActive: false,
  showAccountDetails: false,
  showBillPayModal: false,
  showCheckSuccess: false,
  showCheckEducation: true,
  showCheckError: false,
  showPrintableCheck: false,
  showPrintableCheckModal: false,
  showStatements: false,
  showWriteACheck: false,
  unitToken: '',
  wasWaitlistClicked: false,
  writeCheckInputHints
};

// FIXME(steckel): Remove unitToken from INITIAL_STATE and args intersection
// of initial_state
export const createState = (state = {}) => ({
  ...INITIAL_STATE,
  ...state
});

// State selectors
// -----------------------------------------------------------------------------
export let StateSelector;
(function (_StateSelector) {
  const containsDirectDepositAccountNumber = _StateSelector.containsDirectDepositAccountNumber = state => (state.directDepositAccount?.accountNumber ?? '') !== '';
})(StateSelector || (StateSelector = {}));